var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":_vm.$t('Booking conditions')}},[_c('booking-policy-preview',{attrs:{"policy":_vm.policy,"locale":_vm.$i18n.locale}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }